import { render } from "./BuyListedNftCompletingModal.vue?vue&type=template&id=dc80b4d2&scoped=true"
import script from "./BuyListedNftCompletingModal.vue?vue&type=script&lang=js"
export * from "./BuyListedNftCompletingModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/buyListedNft.scss?vue&type=style&index=0&id=dc80b4d2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc80b4d2"]])

export default __exports__